import styled, { keyframes } from 'styled-components';
import media from 'styled-media-query';
import { generateMedia } from 'styled-media-query';
import LocalizedLink from '../LocalizedLink';
// import { Link } from 'gatsby';

const customMedia = generateMedia({
  mobile: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  laptopXL: "2560px"
})

const appear = keyframes`
  100% {
    transform: translateX(0);
  }
  `;

export const HeaderWrapper = styled.div`
  /*background-color: var(--bg-mid-dark);*/
  ${'' /* background-color: #7b7d81; */}
  ${'' /* background-color: rgba(100, 103, 112, 0.95); */}
  background-color: rgba(70, 70, 73, 0.85);
  flex: 0 0 auto;
  transition: all 50ms ease-in-out;

  ${customMedia.greaterThan('tablet')`
    transform: translateX(-100%);
    animation: ${appear} 800ms ease-in-out forwards 1900ms;
  `}
  /*8500ms;*/

  &:hover {
    background-color: rgba(100, 103, 112, 0.99);
  }
`;



export const LogoLink = styled(LocalizedLink)`
  ${'' /* padding-top: var(--space); */}
  margin-bottom: var(--space-lg);
  align-self: flex-start;
  padding-left: var(--space-sm);

  ${customMedia.greaterThan('tablet')`
    margin-bottom: 1rem;
  `}
`;

export const NavMenu = styled.div`
  margin-bottom: auto; /* put Social links to the bottom */
  align-self: flex-start;

  ${customMedia.greaterThan('tablet')`
    width: 148px;
  `}

  ${customMedia.greaterThan('laptopL')`
    width: 227px;
  `}
`;

export const NavLanguages = styled.div`
  padding: var(--space-sm);
  align-self: flex-end;
  opacity: 0.7;

  ${customMedia.greaterThan('tablet')`
    padding: 2rem 0;
  `}

  ${media.greaterThan('large')`
    margin-bottom: 2rem;
  `}
`;


